import { render, staticRenderFns } from "./CaseDisplayerFilterable.vue?vue&type=template&id=18238232"
import script from "./CaseDisplayerFilterable.vue?vue&type=script&lang=ts"
export * from "./CaseDisplayerFilterable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports